<template>
  <nav class="menu-container">

    <RouterLink
      :exact="item.exact"
      v-for="item in items"
      :key="item.link"
      :to="{ name: item.name }"
      active-class="selected"
      exact-active-class=""
    >
      <div class="icon">
        <Icon :type="item.icon" />
      </div>
      <span>{{ item.title }}</span>
    </RouterLink>
    前海湾站<br>
站点介绍<br>
前海湾站区位于深圳市南山区前海晨文路地下，是深圳地铁1、5、11号线的换乘站。该站区为地下三层结构，三条地铁轨道构成，总面积51428平方米。站址周围是正在开发的前海片区。该站以转乘客为主，早晚高峰换乘客流巨大，节假日更甚，日均换乘客流约150000人次/天。目前出入站客流量约1000人次/天，客流较小，但作为深圳规划的六大重要交通枢纽之一及未来规划中的穗莞深城轨和西部深港快线的换乘通道，前海湾站必定将在深圳交通规划的宏伟蓝图中添上浓墨重彩的一笔。<br><br>
运营时刻表(工作日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
罗湖	06:01	23:22	1号线	2分钟	4分40秒<br>
机场东	06:12	23:46	1号线	2分钟	4分40秒<br>
赤湾	06:14	00:07	5号线	3分钟	5分25秒<br>
黄贝岭	06:13	23:14	5号线	3分钟	5分25秒<br>
岗厦北	06:07	00:14	11号线	4分钟	6分32秒<br>
碧头	06:20	23:52	11号线	4分钟	6分32秒<br><br>
运营时刻表(休息日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
罗湖	06:13	23:21	1号线	3分45秒	5分45秒<br>
机场东	06:36	23:45	1号线	3分45秒	5分45秒<br>
赤湾	06:18	00:07	5号线	4分钟	6分钟<br>
黄贝岭	06:21	23:14	5号线	4分钟	6分钟<br>
岗厦北	06:07	00:14	11号线	4分34秒	6分钟<br>
碧头	06:20	23:52	11号线	4分34秒	6分钟<br><br>
运营时刻表(节假日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
罗湖	06:13	00:21	1号线	3分45秒	5分45秒<br>
机场东	06:36	00:45	1号线	3分45秒	5分45秒<br>
赤湾	06:18	01:07	5号线	4分钟	6分钟<br>
黄贝岭	06:21	00:14	5号线	4分钟	6分钟<br>
岗厦北	06:07	00:14	11号线	4分37秒	6分钟<br>
碧头	06:20	23:52	11号线	4分37秒	6分钟<br><br>
<br>
站点出口信息<br><br>
A出入口:<br>
听海大道东侧（南）、桂湾三路北侧、桂湾四路、前海深港基金小镇、华润前海中心、前海深港青年梦工厂北区<br><br>
B1出入口:<br>
桂湾二路南侧、十一号路、龙海家园<br><br>
公交换乘信息<br><br>
E出入口:<br>
公交站名： 前海湾地铁站总站<br>
B990/M418/M562<br>
</nav>
</template>

<script>
// import Icon from "@/components/Icon";
export default {
  components: {
    // Icon,
  },
  data() {
    return {
      items: [
        {
          name: "yihaoxian",
          title: "1号线",
          // icon: "chat",
          exact: true,
        },
        {
          name: "wuhaoxian",
          title: "5号线",
          // icon: "chat",
          exact: true,
        },
        {
          name: "shiyihaoxian",
          title: "11号线",
          // icon: "chat",
          exact: true,
        },
      ],
    };
  },
};
</script>

<style scoped lang="less">
@import "~@/styles/var.less";
.menu-container {
  color: @words;
  margin: 24px 0;
  a {
    &.selected {
      background: darken(@words, 3%);
    }
    padding: 0 50px;
    display: block;
    display: flex;
    align-items: center;
    height: 45px;
    // .icon {
    //   width: 24px;
    // }
    &:hover {
      color: rgb(50, 95, 227);
    }
  }
}
</style>


